export default __webpack_public_path__ + "static/media/car4.a4002538.jpg";